import FullscreenModal from '@/Components/Common/FullscreenModal.jsx';
import {
    Box,
    Link as MuiLink,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import * as React from 'react';

const cookies = [
    {
        name: 'JSESSIONID',
        source: 'WebSphere',
        goal: 'Ce cookie stocke l’identifiant d’une session, qui communique entre l’application WebSphere et le navigateur de l’utilisateur.',
        moreInfo: '',
    },
];

const CookiesModal = () => {
    return (
        <FullscreenModal title="Politique relative aux cookies">
            <Typography variant="h2" textAlign="center">
                Politique relative aux cookies
            </Typography>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Consentement
                </Typography>
                <Typography>
                    En utilisant ce site Web (domaine du site web à ajouter) (le « site Web »), vous consentez à
                    l’utilisation des cookies conformément à la politique relative aux cookies. Vous aurez remarqué un
                    pop-up à cet effet lors de votre première visite sur ce site Web ; bien qu’il n’apparaisse
                    normalement plus lors des visites ultérieures, vous pouvez retirer votre consentement à tout moment
                    en suivant les instructions ci-dessous.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Désactivation des cookies
                </Typography>
                <Typography>
                    Si vous n’acceptez pas l’utilisation de ces cookies, veuillez les désactiver en suivant les
                    instructions de votre navigateur ici. Veuillez noter que certains services ne fonctionnent pas si
                    les cookies sont désactivés. Lorsque l’organisation qui installe un cookie, fournit un outil
                    automatisé de désactivation pour ses cookies, nous indiquons le nom de cette organisation, la
                    catégorie des cookies qu’elle installe, avec un lien vers l’outil de désactivation automatique. Dans
                    tous les autres cas, nous indiquons les noms des cookies eux-mêmes et leur source, à la date de la
                    politique relative aux cookies, de sorte que vous pouvez facilement les identifier et les
                    désactiver, via les réglages de votre navigateur. Certains navigateurs vous permettent d’indiquer
                    que vous ne voulez pas que votre activité de navigation sur Internet soit suivie. La désactivation
                    du suivi peut interférer avec certaines utilisations du site Web et les services fournis sur le site
                    Web. Après votre première visite sur le site Web, nous pouvons modifier les cookies que nous
                    utilisons. Cette politique relative aux cookies vous permettra toujours de savoir qui installe des
                    cookies, dans quel but, ainsi que de vous donner les moyens de les désactiver. Il convient donc de
                    la consulter de temps en temps.
                </Typography>
            </Box>
            <Box sx={{mb: 8}}>
                <Typography variant="" component="h3">
                    Que sont les cookies ?
                </Typography>
                <Typography>
                    Les cookies sont des fichiers texte contenant de petites quantités d’informations qui sont
                    téléchargées sur votre appareil lorsque vous visitez un site Web. Les cookies sont ensuite envoyés
                    vers le domaine Web d’origine, lors de vos visites ultérieures sur ce domaine. La plupart des pages
                    web contiennent des éléments de plusieurs domaines web, de sorte que lorsque vous visitez le site
                    Web, votre navigateur peut recevoir des cookies de plusieurs sources. Les cookies sont utiles car
                    ils permettent à un site web de reconnaître un périphérique de l’utilisateur. Les cookies vous
                    permettent de naviguer entre les pages de manière efficace, de mémoriser vos préférences et
                    généralement d’améliorer l’expérience utilisateur. Ils peuvent également être utilisés pour adapter
                    la publicité à vos intérêts, grâce au suivi de votre navigation parmi les sites Web. Les cookies de
                    session sont automatiquement supprimés lorsque vous fermez votre navigateur et les cookies
                    permanents restent sur votre appareil après la fermeture du navigateur (par exemple pour mémoriser
                    vos préférences d’utilisateur lorsque vous retournez sur le site).
                </Typography>
            </Box>
            <Typography variant="h2" textAlign="center">
                Paramètres des cookies
            </Typography>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Quels types de cookies utilise Mitsubishi Electric Europe B.V. ?
                </Typography>
                <Typography>
                    Nous décrivons ci-dessous les catégories de cookies que Mitsubishi Electric Europe B.V., ses
                    sociétés affiliées et ses entrepreneurs utilisent.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Cookies strictement nécessaires
                </Typography>
                <Typography>
                    Ces cookies sont indispensables afin de vous permettre de vous déplacer sur le site Web et
                    d’utiliser ses fonctionnalités. Sans ces cookies, les services que vous demandez (comme la
                    navigation entre les pages) ne peuvent pas être fournis. Ce site Web utilise actuellement les
                    cookies strictement nécessaires suivants :
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <TableContainer>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left" sx={{width: '10%'}}>
                                    Nom du cookie
                                </TableCell>
                                <TableCell align="left" sx={{width: '10%'}}>
                                    Source
                                </TableCell>
                                <TableCell align="left" sx={{width: '60%'}}>
                                    Objectif
                                </TableCell>
                                <TableCell align="left" sx={{width: '20%'}}>
                                    Plus d'informations
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {cookies.map((cookie) => (
                                <TableRow key={cookie.name} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                                    <TableCell align="left">{cookie.name}</TableCell>
                                    <TableCell align="left">{cookie.source}</TableCell>
                                    <TableCell align="left">{cookie.goal}</TableCell>
                                    <TableCell align="left">{cookie.moreInfo}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Cookies publicitaires
                </Typography>
                <Typography>
                    Les cookies publicitaires (ou cookies de ciblage) recueillent des informations sur les habitudes de
                    navigation associées à votre appareil. Ils sont utilisés pour rendre la publicité plus pertinente
                    selon vos intérêts. Ils sont également utilisés par les services fournis par des tiers sur ce site
                    Web, tels que les boutons « Aimer » ou « Partager », en plus de fournir la fonctionnalité demandée.
                    Les tiers fournissent ces services en retour pour reconnaître que vous (ou plus exactement votre
                    appareil) avez visité un certain site Web. Ces tiers ont mis en place des cookies publicitaires à la
                    fois lorsque vous visitez notre site Web et lorsque vous utilisez leurs services, ou que vous
                    quittez notre site web. Leurs pratiques en matière de confidentialité sont énoncées ci-dessous. Dans
                    certains cas, vous pouvez choisir de désactiver les cookies publicitaires définis par ces tiers à
                    l’adresse suivante : http://www.youronlinechoices.com/uk/your-ad-choices Pour les autres cas, vous
                    pouvez vérifier les politiques de confidentialité et/ou de désactivation des cookies des tiers. Vous
                    trouverez ci-dessous une liste des possibles tiers qui mettent en place des cookies, ainsi que les
                    liens vers leurs politiques de confidentialité :
                </Typography>
                <Typography component="ul" sx={{mt: 2}}>
                    <Typography component="li">
                        YouTube
                        <Typography component="ul">
                            <Typography component="li">
                                <MuiLink href="https://policies.google.com/privacy?hl=en">
                                    Politique de confidentialité du lecteur vidéo YouTube
                                </MuiLink>{' '}
                                (Conditions générales de Google)
                            </Typography>
                            <Typography component="li">
                                <MuiLink href="https://policies.google.com/technologies/cookies?hl=en">
                                    Politique relative aux cookies du lecteur vidéo YouTube
                                </MuiLink>{' '}
                                (Conditions générales de Google)
                            </Typography>
                            <Typography component="li">
                                <MuiLink href="http://www.google.com/intl/en/policies/privacy/faq/#toc-cookies">
                                    FAQ
                                </MuiLink>{' '}
                                (Conditions générales de Google)
                            </Typography>
                        </Typography>
                    </Typography>

                    <Typography component="li">
                        Brightcove
                        <Typography component="ul">
                            <Typography component="li">
                                <MuiLink href="https://www.brightcove.com/en/legal/services-privacy-policy">
                                    Politique de confidentialité des services Brightcove
                                </MuiLink>
                            </Typography>
                        </Typography>
                    </Typography>
                    <Typography component="li">
                        Matomo
                        <Typography component="ul">
                            <Typography component="li">
                                <MuiLink href="https://matomo.org/privacy-policy/">
                                    Politique de confidentialité de Matomo
                                </MuiLink>
                            </Typography>
                        </Typography>
                    </Typography>
                    <Typography component="li">
                        Facebook
                        <Typography component="ul">
                            <Typography component="li">
                                <MuiLink href="http://www.facebook.com/about/privacy/your-info-on-other">
                                    Politique d’utilisation des données de Facebook
                                </MuiLink>
                            </Typography>
                            <Typography component="li">
                                <MuiLink href="https://www.facebook.com/policies/cookies/">
                                    Politique relative aux cookies de Facebook
                                </MuiLink>
                            </Typography>
                        </Typography>
                    </Typography>
                    <Typography component="li">
                        Twitter
                        <Typography component="ul">
                            <Typography component="li">
                                <MuiLink href="https://twitter.com/en/privacy">
                                    Politique de confidentialité de Twitter
                                </MuiLink>
                            </Typography>
                            <Typography component="li">
                                <MuiLink href="https://help.twitter.com/en/rules-and-policies/twitter-cookies#">
                                    Politique relative aux cookies de Twitter
                                </MuiLink>
                            </Typography>
                        </Typography>
                    </Typography>
                    <Typography component="li">
                        Linkedin
                        <Typography component="ul">
                            <Typography component="li">
                                <MuiLink href="https://www.linkedin.com/legal/privacy-policy?trk=uno-reg-guest-home-privacy-policy">
                                    Politique de confidentialité de Linkedin
                                </MuiLink>
                            </Typography>
                            <Typography component="li">
                                <MuiLink href="https://www.linkedin.com/legal/cookie-policy?trk=uno-reg-guest-home-cookie-policy">
                                    Politique relative aux cookies de Linkedin
                                </MuiLink>
                            </Typography>
                        </Typography>
                    </Typography>
                    <Typography component="li">
                        Google Plus
                        <Typography component="ul">
                            <Typography component="li">
                                <MuiLink href="https://policies.google.com/privacy?hl=en">
                                    Politique de confidentialité de Google
                                </MuiLink>{' '}
                                (Conditions générales de Google)
                            </Typography>
                            <Typography component="li">
                                <MuiLink href="https://policies.google.com/technologies/cookies?hl=en">
                                    Politique relative aux cookies de Google
                                </MuiLink>{' '}
                                (Conditions générales de Google)
                            </Typography>
                            <Typography component="li">
                                <MuiLink href="http://www.google.com/intl/en/policies/privacy/faq/#toc-cookies">
                                    FAQ
                                </MuiLink>{' '}
                                (Conditions générales de Google)
                            </Typography>
                        </Typography>
                    </Typography>
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Objets locaux partagés (« cookies Flash »)
                </Typography>
                <Typography>
                    En plus des cookies ci-dessus, dans certains cas, nous pouvons utiliser sur notre site Web des
                    objets locaux partagés, également appelés « cookies Flash ». Ils sont utilisés pour améliorer votre
                    expérience utilisateur, par exemple, en stockant vos préférences et paramètres utilisateur (tels que
                    vos réglages volume/muet et en rapport avec le contenu animé sur notre site). Les objets locaux
                    partagés sont semblables aux cookies de navigateur, mais peuvent stocker des données plus complexes
                    que du simple texte. En eux-mêmes, ils ne peuvent pas interagir avec les données sur votre
                    ordinateur. Comme les autres cookies, ils ne peuvent accéder qu’à des informations personnellement
                    identifiables que vous avez fournies sur ce site Web, et qui ne peuvent pas être accessibles par
                    d’autres sites Web. Pour en savoir plus sur les cookies Flash ou comment les désactiver, veuillez
                    cliquer ici.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Balises web d’email HTML
                </Typography>
                <Typography>
                    Nos e-mails peuvent contenir un « pixel de balise web » unique, spécifique à une campagne, pour nous
                    informer si nos e-mails sont ouverts et si des clics sont effectués sur les liens de l’e-mail. Nous
                    pouvons utiliser ces informations, par exemple, pour savoir lesquels de nos e-mails vous ont paru
                    les plus intéressants, ou pour savoir si les utilisateurs qui n’ouvrent pas nos e-mails souhaitent
                    continuer à les recevoir. Le pixel sera supprimé lorsque vous supprimez l’e-mail. Si vous ne
                    souhaitez pas que le pixel soit téléchargé sur votre appareil, vous pouvez choisir de recevoir nos
                    e-mails au format texte brut plutôt que HTML.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Utilisation des adresses IP et des journaux Web
                </Typography>
                <Typography>
                    Nous pouvons également utiliser votre adresse IP et le type de votre navigateur pour aider à
                    diagnostiquer des problèmes avec notre serveur, d’administration de notre site Web et pour améliorer
                    le service que nous vous offrons. Une adresse IP est un code numérique qui identifie votre
                    ordinateur sur Internet. Votre adresse IP peut également être utilisée pour recueillir des
                    informations démographiques générales. Nous pouvons effectuer des recherches sur IP pour déterminer
                    de quel domaine vous provenez (par exemple google.com), afin d’évaluer plus précisément les données
                    démographiques de nos utilisateurs.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    La politique relative aux cookies ne couvre pas les sites Web de tiers
                </Typography>
                <Typography>
                    Veuillez noter que cette politique relative aux cookies ne s’applique pas aux pratiques de
                    confidentialité des sites web de tiers qui peuvent être liés à ce site, et que nous ne sommes pas
                    responsables de ces dernières.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Modifications apportées à la politique relative aux cookies
                </Typography>
                <Typography>
                    Nous pouvons mettre à jour cette politique relative aux cookies et nous vous encourageons à examiner
                    la politique de temps en temps pour rester informé de la façon dont nous utilisons les cookies.
                    Cette politique relative aux cookies a été mise à jour le 25 mai 2018
                </Typography>
            </Box>
        </FullscreenModal>
    );
};

export default CookiesModal;
